import {
  CameraTwoTone,
  CloudUploadOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Select,
  UploadProps,
  message,
  theme,
  Image,
  Modal,
} from "antd";
import { useTheme } from "antd-style";
import Dragger from "antd/es/upload/Dragger";
import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../providers/AuthProvider";
import { useUploadOrganizationDocument } from "../api/organization";

import img from "../assets/images/placeholder.jpg";

const options = [
  { label: "Business License", value: "Business License" },
  { label: "Tin Certificate", value: "Tin Certificate" },
  { label: "Other", value: "Other" },
];

type DocumentUploadModalProps = {
  open: boolean;
  selectedId?: string;
  hideModal: () => void;
};

const UploadDocumentModal: React.FC<DocumentUploadModalProps> = ({
  open,
  hideModal,
}) => {
  const {
    mutateAsync: uploadDocument,
    isPending: uploading,
    error,
  } = useUploadOrganizationDocument();
  const [name, setName] = useState<string | undefined>();
  const [documentType, setDocumentType] = useState<string | undefined>();

  const [file, setFile] = useState<File | null | undefined>(undefined);
  const [upload, setUpload] = useState(false);
  const [localPath, setLocalPath] = useState<string | undefined>();

  const [fileExtension, setFileExtension] = useState<string | undefined>();
  const inputFile = useRef<HTMLInputElement>(null);
  const [blob, setBlob] = useState<string | any>("");

  const _uploadDocument = async () => {
    const _documentName = name ? name : documentType;
    if (file && _documentName) {
      const result = await uploadDocument({
        name: _documentName,
        file: blob,
        is_back: false,
      });

      if (error) {
        message.error("Operation failed.");
      } else {
        message.success("Document uploaded successfully.");
      }
    }
    setUpload(false);
    setLocalPath(undefined);
    hideModal();
  };

  return (
    <Modal
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <Button
            key="cancel"
            onClick={hideModal}
            style={{ color: "white", height: 50, alignSelf: "center" }}
          >
            Cancel
          </Button>
          <Button
            loading={uploading}
            key="upload"
            onClick={_uploadDocument}
            type="primary"
            style={{ color: "white", height: 50, alignSelf: "center" }}
            icon={
              <CloudUploadOutlined style={{ fontSize: 40, color: "white" }} />
            }
          >{`${uploading ? "Uploading..." : "Upload"}`}</Button>
        </div>
      }
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          Upload document
        </div>
      }
      open={open}
      centered
      // onOk={hideModal}
      // onCancel={hideModal}
      closable
    >
      <div
        style={{
          borderRadius: 8.5,
          marginTop: 25,
          paddingLeft: 50,
          paddingRight: 50,
          paddingTop: 22,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: 400,
          }}
        >
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 12,
            }}
          >
            <div
              style={{
                height: 250,
                width: 400,
                marginBottom: 12,
                borderRadius: 4,
                position: "relative",
                cursor: "pointer",
                overflow: "hidden",
              }}
              onClick={() => {
                if (inputFile && inputFile.current) {
                  inputFile.current.click();
                }
              }}
            >
              {!localPath && (
                <div style={{ position: "relative" }}>
                  <Image
                    preview={false}
                    src={img}
                    style={{ zIndex: 0, borderRadius: 4 }}
                  />
                  <div
                    style={{
                      fontSize: 22,
                      fontStyle: "bold",
                      color: "#0D5D54",
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      top: 0,
                      left: 0,
                      zIndex: 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Click here to select file.
                  </div>
                </div>
              )}
              {fileExtension && fileExtension !== "pdf" && localPath && (
                <Image
                  preview={false}
                  src={localPath}
                  style={{ borderRadius: 4, aspectRatio: 1 }}
                />
              )}
              {fileExtension && fileExtension === "pdf" && localPath && (
                <iframe src={localPath} width="100%" height="100%" />
              )}
            </div>
            <Select
              value={documentType}
              placeholder="Select document type"
              style={{ width: "100%" }}
              onChange={(val: any) => setDocumentType(val)}
              options={options}
            />
            {documentType === "Other" && (
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Insert document type"
              />
            )}
          </div>
        </div>

        <input
          type="file"
          id="file"
          onChange={async (e) => {
            if (e && e.target && e.target.files) {
              setFile(e.target.files[0]);
              setLocalPath(URL.createObjectURL(e.target.files[0]));
              setUpload(true);

              const fileExt = e.target.files[0].name.split(".").pop();
              setFileExtension(fileExt);
              // let reader = new FileReader();
              // reader.onload = function(_e) {
              //     setBlob(_e.target?.result);
              //   };
              // const b = reader.readAsDataURL(e.target.files[0]);
              setBlob(e.target.files[0]);
            }
          }}
          ref={inputFile}
          style={{ display: "none" }}
        />
      </div>
    </Modal>
  );
};

export default UploadDocumentModal;
